<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5">
      <div class="row">
        <div class="col-md-6">
          <lib-page-header page-title="CONVÊNIO" page-subtitle="EXERCÍCIO: {{login.exercicio.ano}}"
            image-title="assets/img/global/convenio.png">
          </lib-page-header>
        </div>
        <div class="col-md-6">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/convenios']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()" type="submit" class="btn btn-outline-info float-right mr-4"
            style="font-size: 13px">Salvar
            convênio</button>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" href="#tab1" role="tab" data-toggle="tab">Dados do convênio</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#tab3" role="tab" data-toggle="tab">Aditamentos</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#tab2" role="tab" data-toggle="tab">Prestação de contas</a>
        </li>
      </ul>
      <!-- Tab panes -->
      <div class="tab-content">
        <div role="tabpanel" class="tab-pane active" id="tab1">
          <br />
          <div class="row">
            <div class="form-group col-2">
              <label class=" mr-2" style="font-weight: bold; color: #009688 ">CONVÊNIO Nº:<span
                  class="text-danger">*</span></label>
              <input #numero_ id="numero" formControlName="numero" type="text" [unmask]="false"
                [imask]="{mask: '0000/0000'}" class="form-control">
            </div>
            <div class="form-group col-md-2">
              <label for="data_assinatura">Data Assinatura<span class="text-danger">*</span></label>
              <p-calendar id="data_assinatura" formControlName="data_assinatura" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
            <div class="form-group col-md-2">
              <label for="data_termino">Data Contabilização</label>
              <p-calendar id="data_contabilizacao" formControlName="data_contabilizacao" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
            <div class="form-group col-md-2">
              <label for="valor_convenio">Valor convênio</label>
              <input unmask="true" [imask]="imaskConfig" formControlName="valor_convenio" type="text"
                class="form-control" id="valor_convenio" placeholder="0,00" style="font-weight: bold; color: #1e88e5">
            </div>
            <div class="form-group col-md-2">
              <label for="valor_contrapartida">Valor contra partida</label>
              <input unmask="true" [imask]="imaskConfig" formControlName="valor_contrapartida" type="text"
                class="form-control" id="valor_contrapartida" placeholder="0,00"
                style="font-weight: bold; color: #1e88e5">
            </div>
            <div class="col-md-2">
              <label for="processo">Processo<span class="text-danger">*</span></label>
              <input formControlName="processo" type="text" class="form-control" id="processo">
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-2">
              <label for="data_inicio">Data Início<span class="text-danger">*</span></label>
              <p-calendar id="data_inicio" formControlName="data_inicio" inputStyleClass="form-control" dataType="date"
                dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true"
                [style]="{ width: '100%' }">
              </p-calendar>
            </div>
            <div class="form-group col-md-2">
              <label for="data_termino">Data Término</label>
              <p-calendar id="data_termino" formControlName="data_termino" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>

            <div class="form-group col-md-2">
              <label for="autorizacao">Autorização<span class="text-danger">*</span></label>
              <input formControlName="autorizacao" type="text" class="form-control" id="autorizacao">
            </div>


            <div class="form-group col-md-6">
              <label for="tipo_convenio" class="required">Tipo Convênio</label>
              <select [compareWith]="compareFn" id="tipo_convenio" formControlName="tipo_convenio"
                class="custom-select">
                <option [ngValue]="item" *ngFor="let item of listaTipoConvenio">
                  {{item.nome}}
                </option>
              </select>
            </div>

          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="favorecido">Favorecido<span class="text-danger">*</span></label>
              <p-autoComplete formControlName="favorecido" [field]="favorecidoAutoComplete.conversor"
                [suggestions]="favorecidoAutoComplete.lista" (completeMethod)="favorecidoAutoComplete.filtrar($event)"
                placeholder="informe o favorecido" inputStyleClass="form-control font-weight-bold" minLength="2"
                [style]="{ width: '100%' }" (onSelect)="favorecidoAutoComplete.atualizar(true)" [forceSelection]="true"
                [autoHighlight]="true" *ngIf="favorecidoAutoComplete">
                <ng-template let-favorecido pTemplate="item">
                  {{favorecido.cpf_cnpj | CPF}} {{favorecido.nome}}
                </ng-template>
              </p-autoComplete>
            </div>

            <div class="form-group col-md-3">
              <label for="tipo_favorecido" class="required">Tipo Favorecido</label>
              <select [compareWith]="compareFn" id="tipo_favorecido" formControlName="tipo_fornecedor"
                class="custom-select">
                <option [ngValue]="item.id" *ngFor="let item of listaTipoFavorecido">
                  {{item.nome}}
                </option>
              </select>
            </div>
            <div class="form-group col-md-3">
              <label for="origem" class="required">Origem</label>
              <select [compareWith]="compareFn" id="origem" formControlName="origem" class="custom-select">
                <option [ngValue]="item.id" *ngFor="let item of listaOrigem">
                  {{item.nome}}
                </option>
              </select>
            </div>

          </div>
          <hr class="mt-3 mb-2" />
          <div class="row">
            <div class="form-group col-md-6">
              <label for="unidade">Unidade administrativa<span class="text-danger">*</span></label>
              <p-autoComplete formControlName="unidade" [field]="unidadeAutoComplete.conversor" [dropdown]="true"
                [suggestions]="unidadeAutoComplete.lista" (completeMethod)="unidadeAutoComplete.filtrar($event)"
                [ngClass]="{ 'is-invalid': submitted && f.unidade.errors }"
                placeholder="Informe a unidade administrativa" inputStyleClass="form-control font-weight-bold"
                minLength="2" [style]="{ width: '100%', height: '25px' }" [forceSelection]="true" [autoHighlight]="true"
                *ngIf="unidadeAutoComplete">
                <ng-template let-unidade pTemplate="item">
                  {{unidade.codigo}} {{unidade.nome}}
                </ng-template>
              </p-autoComplete>
            </div>
            <div class="form-group col-md-3">
              <label for="especie" class="required">Modalidade</label>
              <select [compareWith]="compareFn" id="especie" formControlName="especie" class="custom-select">
                <option [ngValue]="item.id" *ngFor="let item of listaEspecie">
                  {{item.nome}}
                </option>
              </select>
            </div>
            <div class="form-group col-md-3">
              <label for="siconv">SICONV N˚</label>
              <input formControlName="siconv" type="text" class="form-control" id="siconv">
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label for="finalidade">Finalidade<span class="text-danger">*</span></label>
              <input formControlName="finalidade" type="text" class="form-control" id="finalidade">
            </div>
            <div class="col-md-6">
              <label for="convenente">Convenente<span class="text-danger">*</span></label>
              <input formControlName="convenente" type="text" class="form-control" id="convenente">
            </div>
          </div>
          <hr class="mt-3 mb-2" />
          <div class="row">
            <div class="form-group col-6">
              <label for="recurso">Fonte de recurso<span class="text-danger">*</span></label>
              <p-autoComplete formControlName="recurso" [field]="recursoAutoComplete.conversor"
                [suggestions]="recursoAutoComplete.lista" (completeMethod)="recursoAutoComplete.filtrar($event)"
                placeholder="Informe o nome recurso" inputStyleClass="form-control font-weight-bold" minLength="2"
                [style]="{ width: '100%' }" (onSelect)="recursoAutoComplete.atualizar(true)" [forceSelection]="true"
                [autoHighlight]="true" *ngIf="recursoAutoComplete">
                <ng-template let-recurso pTemplate="item">
                  {{recurso.codigo}} {{recurso.nome}}
                </ng-template>
              </p-autoComplete>
            </div>
            <div class="form-group col-6">
              <label for="aplicacao">Aplicação do recurso<span class="text-danger">*</span></label>
              <p-autoComplete formControlName="aplicacao" [field]="aplicacaoAutoComplete.conversor"
                [suggestions]="aplicacaoAutoComplete.lista" (completeMethod)="aplicacaoAutoComplete.filtrar($event)"
                placeholder="Informe o nome aplicação" inputStyleClass="form-control font-weight-bold" minLength="2"
                [style]="{ width: '100%' }" (onSelect)="aplicacaoAutoComplete.atualizar(true)" [forceSelection]="true"
                [autoHighlight]="true" *ngIf="aplicacaoAutoComplete">
                <ng-template let-aplicacao pTemplate="item">
                  {{aplicacao.codigo}} {{aplicacao.nome}}
                </ng-template>
              </p-autoComplete>
            </div>
          </div>
          <hr class="mt-3 mb-2" />
          <div class="row">
            <div class="form-group col-12">
              <label for="objeto">Objeto<span class="text-danger">*</span></label>
              <textarea formControlName="objeto" class="form-control" id="objeto" rows="5"></textarea>
            </div>
          </div>
          <img src="assets/img/global/bullet_blue.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          <span class="mt-2 font-weight-bold">Comissão de Monitoramento</span>
          <hr class="mt-2 mb-4" />
          <div *ngIf="listaComissoes">
            <app-convenio-comissao [(lista)]="listaComissoes" [(entidade)]="entidade" [login]="login">
            </app-convenio-comissao>
          </div>
          <br>
          <img src="assets/img/global/bullet_blue.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          <span class="mt-2 font-weight-bold">Histório</span>
          <hr class="mt-2 mb-4" />
          <lib-convenio-historico [(lista)]="listaHistoricos" [(entidade)]="entidade" [login]="login">
          </lib-convenio-historico>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="tab2">
          <br />
          <lib-convenio-prestacao [(lista)]="listaPrestacoes" [(entidade)]="entidade" [login]="login">
          </lib-convenio-prestacao>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="tab3">
          <br />
          <lib-convenio-aditamento [(lista)]="listaAditamentos" [(entidade)]="entidade" [login]="login">
          </lib-convenio-aditamento>
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="salvar" title="Salvar" height="20" width="20">
          Salvar & novo
        </button>
      </div>
    </div>
  </form>
</div>